import {mapConfigs} from "./constants";
import {fetch} from "../network";
import {MapSerializer} from "./MapSerializer";

const _ = mapConfigs;
const mapSerializer = MapSerializer();

export function MapController() {

    const geocoder = (body) => {
        return new Promise((resolve, reject) => {
            fetch(_.geocode.method, `${_.geocode.endpoint}/${body}.json?${_.geocode.queryList.join('&')}&access_token=${_.accessToken}`,)
                .then(response => resolve(mapSerializer.geocoderDeserializer(response)))
                .catch(error => reject(error.response))
        });
    }

    return Object.freeze({
        geocoder
    })
}